import { gql } from '@apollo/client';

export const MEDIA_MENU_ITEM_ACTIONS_FRAGMENT = gql`
  fragment MediaMenuItemActions__Media on Media {
    id
    __typename
    name
    duration
    mediaGroupId
    createdAt
    hashedId
    wistiaUrl
    thumbnailUrl
    canAddToChannel
    canShare
    passwordProtected
    hasProcessingEditExport
    algoliaObjectId
    audienceLinks {
      id
      status
      linkUrl
      validFrom
      expiresAt
    }
    liveStreamEvent {
      id
      endedAt
    }
    project {
      id
      name
    }
    stats {
      playCount
    }
    account {
      id
      plan {
        id
        freeTiered
        sku
        version
        premium
      }
    }
    permissionsForCurrentContact {
      canUpdate
      canDelete
      canEmbed
      canDownload
      canViewStats
      canArchive
    }
  }
`;
